import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Footer.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../i18n/translations';
import { portalTranslations } from '../i18n/portalTranslations';

const Footer: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const pt = portalTranslations[language];
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate({ pathname: '/', hash: href.replace('#', '') });
      return;
    }
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t.hero.title}</h3>
            <p>{t.footer.description}</p>
            <p>{t.footer.location}</p>
          </div>
          
          <div className="footer-section">
            <h4>{t.footer.quickLinksTitle}</h4>
            <ul>
              <li><a href="#home" onClick={(e) => handleNavClick(e, '#home')}>{t.navigation.home}</a></li>
              <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')}>{t.navigation.about}</a></li>
              <li><Link to="/credentials">{t.navigation.credentials}</Link></li>
              <li><a href="#regions" onClick={(e) => handleNavClick(e, '#regions')}>{t.regions.title}</a></li>
              <li><a href="#services" onClick={(e) => handleNavClick(e, '#services')}>{t.navigation.services}</a></li>
              <li><Link to="/portal">{pt.navPortal}</Link></li>
              <li><a href="#borders" onClick={(e) => handleNavClick(e, '#borders')}>{t.navigation.borders}</a></li>
              <li><a href="#team" onClick={(e) => handleNavClick(e, '#team')}>{t.navigation.team}</a></li>
              <li><a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>{t.navigation.contact}</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t.footer.contactTitle}</h4>
            <ul>
              {t.contact.infoItems.map((item, index) => {
                // إصلاح اتجاه علامة + للأرقام في العربية
                const text = item.text;
                // تحسين regex ليتعامل مع جميع الأرقام بشكل أفضل
                const phoneRegex = /(\+963[\d\s\|]+)/g;
                const parts = text.split(phoneRegex);
                return (
                  <li key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', flexWrap: 'wrap' }}>
                    <span>{item.icon}</span>
                    <span style={{ flex: 1, wordBreak: 'break-word' }}>
                      {parts.map((part, idx) => {
                        // التحقق من أن الجزء يحتوي على رقم هاتف
                        const isPhoneNumber = /\+963/.test(part);
                        if (isPhoneNumber) {
                          // تنظيف وتنسيق الأرقام
                          const cleanNumber = part.trim();
                          return (
                            <span 
                              key={idx} 
                              dir="ltr" 
                              style={{ 
                                display: 'inline-block', 
                                unicodeBidi: 'embed',
                                fontFamily: 'monospace',
                                direction: 'ltr',
                                textAlign: 'left'
                              }}
                            >
                              {cleanNumber}
                            </span>
                          );
                        }
                        return <span key={idx}>{part}</span>;
                      })}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t.footer.followUs}</h4>
            <div className="social-media">
              <a href="#" className="social-icon" aria-label="Facebook">📘</a>
              <a href="#" className="social-icon" aria-label="Twitter">🐦</a>
              <a href="#" className="social-icon" aria-label="LinkedIn">💼</a>
              <a href="#" className="social-icon" aria-label="WhatsApp">💬</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

